@if (instruction.text || instruction.media) {
  <div class="rich-instructions"
    [ngClass]="{'no-text': !instruction.text}"
    >
    @if (instruction.type) {
      <h5 translate="{{ariaLabelTitleKey}}"></h5>
    }
    @if (instruction.text) {
      <div
        [ngClass]="{'no-media' : !instruction.media}"
        class="instruction-section"
        [innerHTML]="richText">
      </div>
    }
    @if (instruction.media) {
      <media-card
        [media]="instruction.media"
        [ariaLabelTitleKey]="ariaLabelTitleKey">
      </media-card>
    }
  </div>
}
